import moment from "moment"

export const calculateAge = birthDate => {
  const today = new Date()
  const birth = new Date(birthDate)
  let age = today.getFullYear() - birth.getFullYear()
  const m = today.getMonth() - birth.getMonth()
  if (m < 0 || (m === 0 && today.getDate() < birth.getDate())) {
    age--
  }
  return age
}

export const formatAnyTime = t => {
  if (!t) return "-"

  // Normalize "6:13 p.m." / "6:13 a.m." to "6:13 PM" / "6:13 AM"
  const normalized = String(t)
    .replace(/p\.m\./gi, "PM")
    .replace(/a\.m\./gi, "AM")
    .replace(/\bpm\b/gi, "PM")
    .replace(/\bam\b/gi, "AM")
    .trim()

  const formats = [
    "HH:mm",
    "HH:mm:ss",
    "hh:mm A",
    "hh:mm:ss A",
    "h:mm A",
    "h:mm:ss A",
    "H:mm",
  ]

  for (let f of formats) {
    const m = moment(normalized, f, true)
    if (m.isValid()) {
      return m.format("hh:mm A")
    }
  }

  const auto = moment(normalized)
  if (auto.isValid()) return auto.format("hh:mm A")

  return "-"
}
